module.exports = __webpack_public_path__ + "static/media/face-tablet.c4cb8904.webp";